module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "letteringList flexcenter"
  }, [_c('div', {
    staticClass: "letteringListDialog flexcenter"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "letteringListInner"
  }, [_c('h3', [_vm._v("学習言語の文字と発音")]), _vm._v(" "), _c('div', {
    staticClass: "modal-inner"
  }, [_c('div', {
    staticClass: "letters"
  }, [_c('div', {
    staticClass: "flexbox"
  }, _vm._l((_vm.characters), function(item, index) {
    return _c('div', {
      staticClass: "letter",
      class: {
        active: _vm.selectedLetter == index
      },
      style: ({
        fontSize: _vm.letterFontSize
      }),
      on: {
        "click": function($event) {
          return _vm.selectCharacter(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.text))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.characterText != ''),
      expression: "characterText != ''"
    }],
    staticClass: "icon-voice",
    on: {
      "click": function($event) {
        return _vm.characterAudioPlay(_vm.characterSound)
      }
    }
  }), _c('h4', {
    staticClass: "textgreen2",
    style: ({
      fontSize: _vm.titleFontSize
    })
  }, [_vm._v(_vm._s(_vm.characterText))])]), _vm._v(" "), _c('div', {
    staticClass: "section-content"
  }, _vm._l((_vm.phoneticList), function(phoneticItem, phoneticIndex) {
    return _c('div', {
      staticClass: "section-group"
    }, [_vm._l((phoneticItem), function(childItem, childIndex) {
      return _c('div', {
        staticClass: "word",
        style: ({
          fontSize: _vm.wordFontSize
        })
      }, [_c('button', {
        staticClass: "icon-voice",
        on: {
          "click": function($event) {
            return _vm.characterAudioPlay(childItem.sound)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "word-group"
      }, [_vm._l((childItem.scripts), function(scriptItem, scriptIndex) {
        return [_c('span', {
          staticClass: "word-group-item",
          domProps: {
            "innerHTML": _vm._s(_vm.getDispText(scriptItem))
          }
        })]
      })], 2)])
    })], 2)
  }), 0)])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ace2835", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-2ace2835","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguageLetter.vue
// module id = 858
// module chunks = 1